import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/layout";
import SplittedScreen from "../../components/splittedScreen";
import ForgotComponent from "../../components/forgotPassword";
import InvitePageComponent from "../../components/invitePage";
import { Route, Routes } from "react-router-dom";

const ForgotInviteSplit = () => (
  <SplittedScreen>
    <InvitePageComponent isForgot={true} />
  </SplittedScreen>
);

const ForgotSplit = () => (
  <SplittedScreen>
    <ForgotComponent />
  </SplittedScreen>
);

const ForgotPassword = props => (
  <main>
    <Helmet title="Home" />
    <Layout>
      <Routes>
        <Route path={`:operationId`} element={<ForgotInviteSplit />} />
        <Route path="/" element={<ForgotSplit />} />
      </Routes>
    </Layout>
  </main>
);

export default ForgotPassword;
